import { createI18n } from 'vue-i18n'

import de from '@/locales/de'
import en from '@/locales/en'
import tr from '@/locales/tr'

import { DEFAULT_LOCALE, isSelectableLocale, type SupportedLocale } from './constants'

const STORAGE_KEY = 'lms.locale'

/** Stored choice first, otherwise German. A saved Turkish choice falls back to German. */
function resolveInitialLocale(): SupportedLocale {
  const stored = localStorage.getItem(STORAGE_KEY)
  if (isSelectableLocale(stored)) return stored
  return DEFAULT_LOCALE
}

export const i18n = createI18n({
  legacy: false,
  locale: resolveInitialLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  globalInjection: true,
  // German is the default; missing keys fall back to it without a console warning.
  missingWarn: import.meta.env.DEV,
  fallbackWarn: false,
  messages: { en, tr, de },
})

export function setLocale(locale: SupportedLocale): void {
  const next: SupportedLocale = isSelectableLocale(locale) ? locale : DEFAULT_LOCALE
  i18n.global.locale.value = next
  localStorage.setItem(STORAGE_KEY, next)
  document.documentElement.lang = next
}

export function currentLocale(): SupportedLocale {
  return i18n.global.locale.value as SupportedLocale
}

document.documentElement.lang = i18n.global.locale.value
